import Joi from 'joi';

// Mirror van LoadCsCodeGenConfigDlgSchema.js — createLayout() labels blijven in sync met
// Joi-errors via .label().
export const createLayout = () => ({
  rk: { label: 'RowKey', control: 'text' },
  name: { label: 'Naam', control: 'text' },
  service: { label: 'Service', control: 'text' },
  format: { label: 'Format', control: 'text' },
  remarks: { label: 'Remarks', control: 'text' },
});

export const createSchema = () => {
  const layout = createLayout();
  return {
    rk: Joi.string().max(256).allow(null, '').label(layout.rk.label),
    name: Joi.string().max(256).required().label(layout.name.label),
    service: Joi.string().max(256).allow('').label(layout.service.label),
    format: Joi.string().max(64).allow('').label(layout.format.label),
    remarks: Joi.string().max(2000).allow('').label(layout.remarks.label),
  };
};
